import { render, staticRenderFns } from "./ContentOrderDetailList.vue?vue&type=template&id=768f2dba&scoped=true"
import script from "./ContentOrderDetailList.vue?vue&type=script&lang=js"
export * from "./ContentOrderDetailList.vue?vue&type=script&lang=js"
import style0 from "./ContentOrderDetailList.vue?vue&type=style&index=0&id=768f2dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f2dba",
  null
  
)

export default component.exports